const css = `/**
 * Colors
 */
@media (max-width: 782px) {
  * {
    view-transition-name: none !important;
  }
}
::view-transition-old(root),
::view-transition-new(root) {
  animation-duration: 250ms;
}

@media not (prefers-reduced-motion: reduce) {
  .boot-layout__canvas .interface-interface-skeleton__header {
    view-transition-name: boot--canvas-header;
  }
  .boot-layout__canvas .interface-interface-skeleton__sidebar {
    view-transition-name: boot--canvas-sidebar;
  }
  .boot-layout.has-full-canvas .boot-layout__canvas .boot-site-icon-link,
  .boot-layout:not(.has-full-canvas) .boot-site-hub .boot-site-icon-link {
    view-transition-name: boot--site-icon-link;
  }
  .boot-layout__stage {
    view-transition-name: boot--stage;
  }
  .boot-layout__inspector {
    view-transition-name: boot--inspector;
  }
  .boot-layout__canvas:not(.is-full-canvas),
  .boot-layout__canvas.is-full-canvas .interface-interface-skeleton__content {
    view-transition-name: boot--canvas;
  }
  @supports (-webkit-hyphens: none) and (not (-moz-appearance: none)) {
    .boot-layout__stage {
      view-transition-name: boot-safari--stage;
    }
    .boot-layout__inspector {
      view-transition-name: boot-safari--inspector;
    }
    .boot-layout__canvas:not(.is-full-canvas),
    .boot-layout__canvas.is-full-canvas .interface-interface-skeleton__content {
      view-transition-name: boot-safari--canvas;
    }
  }
  .components-popover:first-of-type {
    view-transition-name: boot--components-popover;
  }
}
::view-transition-group(boot--canvas-header),
::view-transition-group(boot--canvas-sidebar),
::view-transition-group(boot-safari--canvas),
::view-transition-group(boot--canvas) {
  z-index: 1;
}

::view-transition-group(boot--site-icon-link) {
  z-index: 2;
}

::view-transition-new(boot--site-icon-link),
::view-transition-old(boot--site-icon-link) {
  animation: none;
}

::view-transition-new(boot-safari--canvas),
::view-transition-old(boot-safari--canvas),
::view-transition-new(boot-safari--stage),
::view-transition-old(boot-safari--stage),
::view-transition-old(boot-safari--inspector),
::view-transition-new(boot-safari--inspector) {
  width: auto;
}

::view-transition-new(boot--canvas),
::view-transition-old(boot--canvas),
::view-transition-new(boot--stage),
::view-transition-old(boot--stage),
::view-transition-new(boot--inspector),
::view-transition-old(boot--inspector) {
  background: #fff;
  border-radius: 8px;
  width: 100%;
  height: 100%;
  object-fit: none;
  object-position: left top;
  overflow: hidden;
}

::view-transition-new(boot--canvas),
::view-transition-old(boot--canvas) {
  object-position: center top;
}

::view-transition-old(boot-safari--inspector):only-child,
::view-transition-old(boot--inspector):only-child,
::view-transition-old(boot-safari--stage):only-child,
::view-transition-old(boot--stage):only-child {
  animation-name: zoomOut;
  will-change: transform, opacity;
}

::view-transition-new(boot-safari--inspector):only-child,
::view-transition-new(boot--inspector):only-child,
::view-transition-new(boot-safari--stage):only-child,
::view-transition-new(boot--stage):only-child {
  animation-name: zoomIn;
  will-change: transform, opacity;
}

@keyframes zoomOut {
  from {
    transform: scale(1);
    opacity: 1;
  }
  to {
    transform: scale(0.9);
    opacity: 0;
  }
}
@keyframes zoomIn {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
::view-transition-new(boot-safari--canvas):only-child,
::view-transition-new(boot--canvas):only-child {
  animation-name: slideFromRight;
  will-change: transform;
}

::view-transition-old(boot-safari--canvas):only-child,
::view-transition-old(boot--canvas):only-child {
  animation-name: slideToRight;
  will-change: transform;
}

@keyframes slideFromRight {
  from {
    transform: translateX(100vw);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes slideToRight {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100vw);
  }
}
::view-transition-new(boot--canvas-header):only-child {
  animation-name: slideHeaderFromTop;
  will-change: transform;
}

::view-transition-old(boot--canvas-header):only-child {
  animation-name: slideHeaderToTop;
  will-change: transform;
}

@keyframes slideHeaderFromTop {
  from {
    transform: translateY(-100%);
  }
}
@keyframes slideHeaderToTop {
  to {
    transform: translateY(-100%);
  }
}
::view-transition-new(boot--canvas-sidebar):only-child {
  animation-name: slideSidebarFromRight;
  will-change: transform;
}

::view-transition-old(boot--canvas-sidebar):only-child {
  animation-name: slideSidebarToRight;
  will-change: transform;
}

@keyframes slideSidebarFromRight {
  from {
    transform: translateX(100%);
  }
}
@keyframes slideSidebarToRight {
  to {
    transform: translateX(100%);
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
